/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiAttachToCasesRequest,
    InternalApiAttachToCasesRequestFromJSON,
    InternalApiAttachToCasesRequestToJSON,
    InternalApiCase,
    InternalApiCaseFromJSON,
    InternalApiCaseToJSON,
    InternalApiCaseDetails,
    InternalApiCaseDetailsFromJSON,
    InternalApiCaseDetailsToJSON,
    InternalApiCasePage,
    InternalApiCasePageFromJSON,
    InternalApiCasePageToJSON,
    InternalApiCreateCaseRequest,
    InternalApiCreateCaseRequestFromJSON,
    InternalApiCreateCaseRequestToJSON,
    InternalApiFindCaseHandlesRequest,
    InternalApiFindCaseHandlesRequestFromJSON,
    InternalApiFindCaseHandlesRequestToJSON,
    InternalApiFindCasesPageRequest,
    InternalApiFindCasesPageRequestFromJSON,
    InternalApiFindCasesPageRequestToJSON,
    InternalApiUpdateCaseDetailsRequest,
    InternalApiUpdateCaseDetailsRequestFromJSON,
    InternalApiUpdateCaseDetailsRequestToJSON,
} from '../models';

export interface ArchiveCaseRequest {
    handle: string;
}

export interface AttachToCasesRequest {
    internalApiAttachToCasesRequest: InternalApiAttachToCasesRequest;
}

export interface CreateCaseRequest {
    internalApiCreateCaseRequest: InternalApiCreateCaseRequest;
}

export interface FindCaseByHandleRequest {
    handle: string;
}

export interface FindCaseHandlesRequest {
    internalApiFindCaseHandlesRequest: InternalApiFindCaseHandlesRequest;
}

export interface FindCasesPageRequest {
    internalApiFindCasesPageRequest: InternalApiFindCasesPageRequest;
}

export interface UpdateCaseDetailsRequest {
    handle: string;
    internalApiUpdateCaseDetailsRequest: InternalApiUpdateCaseDetailsRequest;
}

/**
 * 
 */
export class CaseInternalApi extends runtime.BaseAPI {

    /**
     * Archives a case
     */
    async archiveCaseRaw(requestParameters: ArchiveCaseRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling archiveCase.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Archives a case
     */
    async archiveCase(requestParameters: ArchiveCaseRequest, initOverrides?: RequestInit): Promise<void> {
        await this.archiveCaseRaw(requestParameters, initOverrides);
    }

    /**
     * Attach entities to multiple cases
     */
    async attachToCasesRaw(requestParameters: AttachToCasesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiAttachToCasesRequest === null || requestParameters.internalApiAttachToCasesRequest === undefined) {
            throw new runtime.RequiredError('internalApiAttachToCasesRequest','Required parameter requestParameters.internalApiAttachToCasesRequest was null or undefined when calling attachToCases.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/attachments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiAttachToCasesRequestToJSON(requestParameters.internalApiAttachToCasesRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Attach entities to multiple cases
     */
    async attachToCases(requestParameters: AttachToCasesRequest, initOverrides?: RequestInit): Promise<void> {
        await this.attachToCasesRaw(requestParameters, initOverrides);
    }

    /**
     * Creates a new case
     */
    async createCaseRaw(requestParameters: CreateCaseRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCase>> {
        if (requestParameters.internalApiCreateCaseRequest === null || requestParameters.internalApiCreateCaseRequest === undefined) {
            throw new runtime.RequiredError('internalApiCreateCaseRequest','Required parameter requestParameters.internalApiCreateCaseRequest was null or undefined when calling createCase.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCreateCaseRequestToJSON(requestParameters.internalApiCreateCaseRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCaseFromJSON(jsonValue));
    }

    /**
     * Creates a new case
     */
    async createCase(requestParameters: CreateCaseRequest, initOverrides?: RequestInit): Promise<InternalApiCase> {
        const response = await this.createCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches a single case by handle
     */
    async findCaseByHandleRaw(requestParameters: FindCaseByHandleRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCase>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling findCaseByHandle.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCaseFromJSON(jsonValue));
    }

    /**
     * Fetches a single case by handle
     */
    async findCaseByHandle(requestParameters: FindCaseByHandleRequest, initOverrides?: RequestInit): Promise<InternalApiCase> {
        const response = await this.findCaseByHandleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches case handles matching filters
     */
    async findCaseHandlesRaw(requestParameters: FindCaseHandlesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.internalApiFindCaseHandlesRequest === null || requestParameters.internalApiFindCaseHandlesRequest === undefined) {
            throw new runtime.RequiredError('internalApiFindCaseHandlesRequest','Required parameter requestParameters.internalApiFindCaseHandlesRequest was null or undefined when calling findCaseHandles.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/handles`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiFindCaseHandlesRequestToJSON(requestParameters.internalApiFindCaseHandlesRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Fetches case handles matching filters
     */
    async findCaseHandles(requestParameters: FindCaseHandlesRequest, initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.findCaseHandlesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches paginated cases for the organisation
     */
    async findCasesPageRaw(requestParameters: FindCasesPageRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCasePage>> {
        if (requestParameters.internalApiFindCasesPageRequest === null || requestParameters.internalApiFindCasesPageRequest === undefined) {
            throw new runtime.RequiredError('internalApiFindCasesPageRequest','Required parameter requestParameters.internalApiFindCasesPageRequest was null or undefined when calling findCasesPage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/page`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiFindCasesPageRequestToJSON(requestParameters.internalApiFindCasesPageRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCasePageFromJSON(jsonValue));
    }

    /**
     * Fetches paginated cases for the organisation
     */
    async findCasesPage(requestParameters: FindCasesPageRequest, initOverrides?: RequestInit): Promise<InternalApiCasePage> {
        const response = await this.findCasesPageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a case\'s details
     */
    async updateCaseDetailsRaw(requestParameters: UpdateCaseDetailsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCaseDetails>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling updateCaseDetails.');
        }

        if (requestParameters.internalApiUpdateCaseDetailsRequest === null || requestParameters.internalApiUpdateCaseDetailsRequest === undefined) {
            throw new runtime.RequiredError('internalApiUpdateCaseDetailsRequest','Required parameter requestParameters.internalApiUpdateCaseDetailsRequest was null or undefined when calling updateCaseDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/details`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiUpdateCaseDetailsRequestToJSON(requestParameters.internalApiUpdateCaseDetailsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCaseDetailsFromJSON(jsonValue));
    }

    /**
     * Updates a case\'s details
     */
    async updateCaseDetails(requestParameters: UpdateCaseDetailsRequest, initOverrides?: RequestInit): Promise<InternalApiCaseDetails> {
        const response = await this.updateCaseDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
